module.exports = __webpack_public_path__ + "img/symbol_6.9003bee1.png";